<div class=" container">
  <div class="login-wrapper">
    <div class="login-form">
      <mat-form-field subscriptSizing="dynamic" class="login-input">
        <mat-label>Login</mat-label>
        <input matInput [(ngModel)]="username">
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="password-input">
        <mat-label>Passwort</mat-label>
        <input type="password" matInput [(ngModel)]="password">
      </mat-form-field>

      <button mat-raised-button (click)="login()">LOGIN</button>
    </div>
  </div>
</div>

